module.exports = __webpack_public_path__ + "static/img/one.2871036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/3/one.png
// module id = 8/f+
// module chunks = 1